import React from 'react';
import PropTypes from 'prop-types';

import InputItem from '../form/inputitem';
import TextareaItem from '../form/textareaitem';
import SelectItem from '../form/selectitem';
import SwitchItem from '../form/switchitem';
import ModalFooter from '../modalfooter';

class CommonForm extends React.PureComponent {
    render() {
        const { show_first_input,show_second_input, show_first_textarea, show_first_select, show_second_select, show_third_select, show_first_switch, show_second_switch, first_input_props, second_input_props, first_textarea_props, first_select_props, second_select_props, third_select_props, first_switch_props, second_switch_props, modal_footer_props } = this.props;

        return (
            <div className="ori-pad-15">
                <div className="ori-lr-pad-10 ori-b-pad-10">
                    {
                        show_first_input &&
                        <InputItem {...first_input_props} />
                    }
                    {
                        show_second_input &&
                        <InputItem {...second_input_props} />
                    }
                    {
                        show_first_textarea &&
                        <TextareaItem {...first_textarea_props} />
                    }
                    {
                        show_first_select &&
                        <SelectItem {...first_select_props} />
                    }
                    {
                        show_second_select &&
                        <SelectItem {...second_select_props} />
                    }
                    {
                        show_third_select &&
                        <SelectItem {...third_select_props} />
                    }
                    {
                        show_first_switch &&
                        <SwitchItem {...first_switch_props} />
                    }
                    {
                        show_second_switch &&
                        <SwitchItem {...second_switch_props} />
                    }
                </div>
                <ModalFooter {...modal_footer_props} />
            </div>
        );
    }
}

CommonForm.propTypes = {
    show_first_input: PropTypes.bool,
    show_second_input: PropTypes.bool,
    show_first_textarea: PropTypes.bool,
    show_first_select: PropTypes.bool,
    show_second_select: PropTypes.bool,
    show_third_select: PropTypes.bool,
    show_first_switch: PropTypes.bool,
    show_second_switch: PropTypes.bool,
    first_input_props: PropTypes.object,
    second_input_props: PropTypes.object,
    first_textarea_props: PropTypes.object,
    first_select_props: PropTypes.object,
    second_select_props: PropTypes.object,
    third_select_props: PropTypes.object,
    first_switch_props: PropTypes.object,
    second_switch_props: PropTypes.object,
    modal_footer_props: PropTypes.object,
};

CommonForm.defaultProps = {
    show_first_input: false,
    show_first_textarea: false,
    show_first_select: false,
    show_second_select: false,
    show_third_select: false,
    show_first_switch: false,

    first_input_props: {},
    first_textarea_props: {},
    first_select_props: {},
    second_select_props: {},
    third_select_props: {},
    first_switch_props: {},
    second_switch_props: {},
    modal_footer_props: {},
};

export default CommonForm;



// WEBPACK FOOTER //
// ./src/components/commonform/index.js